import { render } from "./Avatar.vue?vue&type=template&id=377956ce&scoped=true"
import script from "./Avatar.vue?vue&type=script&lang=js"
export * from "./Avatar.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-377956ce"

export default script